//@flow
import { connect } from 'react-redux';
import SelfieCheck from './SelfieCheck';
import { setSelfieIdentification } from '../../../modules/SignUp/Identifications';
import { getCurrentRoute } from '../../../lib/navigation';

const mapStateToProps = state => ({
  cameraActivated: getCurrentRoute() === 'selfieCheck',
});

const mapDispatchToProps = {
  setSelfieIdentification,
};

export default connect(mapStateToProps, mapDispatchToProps)(SelfieCheck);
